var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPump(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99951 19.001L11.9996 12.0009L18.9996 19.001H4.99951Z",
    fill: "#002D62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0005 6.86646e-05H23.0006V3.00009H12.0005V6.86646e-05Z",
    fill: "#0679CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 0.500798H26V2.50082H23V0.500798Z",
    fill: "#002D62"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.06193 7.00013C4.02108 7.32773 4.00004 7.66148 4.00004 8.00014C4.00004 8.3388 4.02108 8.67255 4.06193 9.00015H0V7.00013H4.06193ZM4.06193 7.00013C4.55403 3.05378 7.92045 6.86646e-05 12.0001 6.86646e-05C16.4184 6.86646e-05 20.0002 3.58182 20.0002 8.00014C20.0002 12.4185 16.4184 16.0002 12.0001 16.0002C7.92045 16.0002 4.55403 12.9465 4.06193 9.00015H10.2677C10.6135 9.59796 11.2598 10.0002 12.0001 10.0002C13.1047 10.0002 14.0001 9.10472 14.0001 8.00014C14.0001 6.89556 13.1047 6.00012 12.0001 6.00012C11.2598 6.00012 10.6135 6.40232 10.2677 7.00013H4.06193Z",
    fill: "#0679CC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99951 19.0004H18.9996V20.0004H4.99951V19.0004Z",
    fill: "#012946"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.00045H4.00004V9.00047H0V7.00045Z",
    fill: "#002D62"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.00032H4.00004V9.00034H0V7.00032Z",
    fill: "#002D62"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 10.0003C13.1046 10.0003 14 9.10489 14 8.00032C14 6.89575 13.1046 6.00032 12 6.00032C11.2597 6.00032 10.6134 6.40252 10.2676 7.00032H4V9.00032H10.2676C10.6134 9.59812 11.2597 10.0003 12 10.0003Z",
    fill: "#002D62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPump);
export default __webpack_public_path__ + "static/media/pump.ac781063e298619cb8725874be4c763a.svg";
export { ForwardRef as ReactComponent };